import { createFileRoute, Link } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

import { useT } from "@/lib/i18n";

export const Route = createFileRoute("/platba/uspech")({
  ssr: false,
  component: PaymentSuccessPage,
  head: () => ({
    meta: [
      { title: "Platba úspěšná — Cerveza.International" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});

function PaymentSuccessPage() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-background">

      <div className="mx-auto max-w-xl px-4 py-16 text-center">
        <CheckCircle2 className="mx-auto mb-4 h-16 w-16 text-emerald-600" />
        <h1 className="font-serif text-3xl">{t("pay.successTitle")}</h1>
        <p className="mt-3 text-muted-foreground">{t("pay.successDesc")}</p>
        <Button asChild className="mt-6">
          <Link to="/moje-podniky">{t("pay.backToMy")}</Link>
        </Button>
      </div>
    </div>
  );
}
